import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import { global } from '../../Models/global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FmcToSdService {

  ROOT_URL: string = "";
  constructor(private http: Http) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }
  uploadDocument(documents: File, UserId: string): Observable<any> {
    const formData = new FormData();
    formData.append("file", documents);
    formData.append("UserId", UserId);
    let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/FmcToSd/UploadFiles",
      headers: headers,
      body: formData
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }
  DownloadExcel(userId: string): Observable<any> {
    let url = this.ROOT_URL + '/api/FmcToSd/DownloadExcel?userId=' + userId;
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'GET',
      url: url,
      headers: headers,
      responseType: ResponseContentType.Blob
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }
  ShowDataOnScreen(userId: any, currentPage: any): Observable<any> {
    let url = this.ROOT_URL + '/api/FmcToSd/GetFmcToSdData';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let body = { "userId": userId, "currentPage": currentPage };
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }



}
